module.exports = __webpack_public_path__ + "static/media/india.35661f60.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/india.png
 ** module id = 452
 ** module chunks = 0
 **/